import { createSlice } from '@reduxjs/toolkit';
import { Course, Test } from 'global/types';

interface ClassroomState {
    isFetchingClassroom: boolean;
    courses: Course[];
    tests: Test[];
};

const initialState: ClassroomState = {
    isFetchingClassroom: true, 
    courses: [], 
    tests: []
};

export const classroomSlice = createSlice({
    name: 'classroom',
    initialState,
    reducers: {
        updateClassroom: (state, action) => {
            const { courses, tests } = action.payload;

            state.courses = courses ? courses : state.courses;
            state.tests = tests ? tests : state.tests;
            state.isFetchingClassroom = false;
        },
        resetClassroom: state => {
            state.courses = initialState.courses;
            state.tests = initialState.tests;
            state.isFetchingClassroom = initialState.isFetchingClassroom;
        }
    }
});

export const { updateClassroom, resetClassroom } = classroomSlice.actions;

export default classroomSlice.reducer;